import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "Tasty Concoctions",
  date: new Date(2024, 11, 22),
  img: "/img/conversation.jpeg",
  tracks: [
    {
      title: "Complicit Interactions",
      src: "/songs/2024-12-22/complicit_interactions.mp3",
      duration: 819.336,
    },
    {
      title: "Winter Solstice",
      src: "/songs/2024-12-22/winter_solstice.mp3",
      duration: 876.384,
    },
    {
      title: "Dangling Participle",
      src: "/songs/2024-12-22/dangling_participle.mp3",
      duration: 811.056,
    },
    {
      title: "Let's Go Sailing",
      src: "/songs/2024-12-22/lets_go_sailing.mp3",
      duration: 722.904,
    },
    {
      title: "Seams In The Fabric",
      src: "/songs/2024-12-22/seams_in_the_fabric.mp3",
      duration: 1516.32,
    },
    {
      title: "Information Withheld",
      src: "/songs/2024-12-22/information_withheld.mp3",
      duration: 838.056,
    },
    {
      title: "Ultraviolet Dreams",
      src: "/songs/2024-12-22/ultraviolet_dreams.mp3",
      duration: 792.768,
    },
    {
      title: "Good Conversation",
      src: "/songs/2024-12-22/good_conversation.mp3",
      duration: 727.56,
    },
    {
      title: "Excited Particles",
      src: "/songs/2024-12-22/excited_particles.mp3",
      duration: 418.296,
    },
    {
      title: "Deep Sea Expedition",
      src: "/songs/2024-12-22/deep_sea_expedition.mp3",
      duration: 902.448,
    },
    {
      title: "React!",
      src: "/songs/2024-12-22/react.mp3",
      duration: 570.768,
    },
  ],
};
export default album;
